import React from 'react';
import { classes } from './Footer.classes';
import { Button } from '../../../Button';
import { dataHooks } from '../../constants';
import { Divider } from '../../../Divider';
import { useBaseModalLayoutContext } from '../../BaseModalLayoutContext';
import { Tooltip } from '../../../Tooltip';
import { FooterProps } from './Footer.types';

export const Footer = ({
  dataHook,
  className,
  showFooterDivider = false,
}: FooterProps) => {
  const {
    footerClassName,
    skin,
    actionsSize,
    sideActions,
    secondaryButtonText,
    secondaryButtonOnClick,
    secondaryButtonProps,
    primaryButtonText,
    primaryButtonOnClick,
    primaryButtonProps,
    primaryButtonTooltipProps,
  } = useBaseModalLayoutContext();
  const hasPrimaryButton =
    primaryButtonText || primaryButtonOnClick || primaryButtonProps;
  const hasSecondaryButton =
    secondaryButtonText || secondaryButtonOnClick || secondaryButtonProps;
  const hasFooter = hasPrimaryButton || hasSecondaryButton || sideActions;

  return (
    (hasFooter && (
      <div
        data-hook={dataHook}
        data-divider={showFooterDivider}
        className={classes.root(
          { showDivider: showFooterDivider },
          footerClassName,
          className,
        )}
      >
        <Divider
          className={classes.divider()}
          dataHook={dataHooks.footerDivider}
        />
        <div className={classes.innerContent()}>
          {sideActions && (
            <div
              data-hook={dataHooks.footerSideActions}
              className={classes.sideActions()}
            >
              {sideActions}
            </div>
          )}
          {(hasPrimaryButton || hasSecondaryButton) && (
            <div className={classes.actions()}>
              {hasSecondaryButton && (
                <Button
                  skin={skin}
                  size={actionsSize}
                  onClick={secondaryButtonOnClick}
                  priority="tertiary"
                  dataHook={dataHooks.footerSecondaryButton}
                  {...(secondaryButtonProps as any)}
                  internalDataHook={dataHooks.footerSecondaryButton}
                >
                  {secondaryButtonText ||
                    (secondaryButtonProps && secondaryButtonProps.children)}
                </Button>
              )}
              {hasPrimaryButton && (
                <Tooltip
                  dataHook={dataHooks.primaryButtonTooltip}
                  disabled={!primaryButtonTooltipProps?.content}
                  {...primaryButtonTooltipProps}
                >
                  <Button
                    skin={skin}
                    size={actionsSize}
                    onClick={primaryButtonOnClick}
                    dataHook={dataHooks.footerPrimaryButton}
                    {...(primaryButtonProps as any)}
                    internalDataHook={dataHooks.footerPrimaryButton}
                  >
                    {primaryButtonText || primaryButtonProps?.children}
                  </Button>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      </div>
    )) ||
    null
  );
};

Footer.displayName = 'BaseModalLayout.Footer';
